import { FC } from "react";
// Misc
import CloseIcon from "../../assets/images/closeIcon.png";
import "./Modal.scss";

export const Modal: FC<any> = ({ children, onClose, showCloseButton }) => {
  const CloseButton = () => {
    if (!showCloseButton) return null;

    return (
      <div className="modalCloseButton" onClick={onClose}>
        <img src={CloseIcon} alt="Close icon" />
      </div>
    );
  };

  const handleClick = (e: any) => {
    if (!onClose) return null;
    if (e.target.className === "modalComp") onClose();
  };

  return (
    <div className="modalComp" onClick={handleClick}>
      <CloseButton />
      <div className="modalContent">{children}</div>
    </div>
  );
};

export default Modal;
